import device from "bits/device"

let alreadyFixing = false

const fixViewportHeight = () => {
  const height = window.innerHeight
  const scrollY = window.scrollY
  if(typeof document.documentElement.style.setProperty === "function") {
    document.documentElement.style.setProperty("--vh100", `${height}px`)
    document.documentElement.style.setProperty("--top0", `${scrollY}px`)
  }
}

const fixMobileViewport = () => {
  if(device.mobile && !device.app && !alreadyFixing) {
    window.addEventListener("resize", (e) => {
      if(e.target == window)
      fixViewportHeight()
    })
    window.addEventListener("scroll", (e) => {
      // looks like scroll events don't bubble.
      fixViewportHeight()
    })
    alreadyFixing = true
    fixViewportHeight()
  }
}

export default fixMobileViewport